import { render, staticRenderFns } from "./mitra-tna-report.vue?vue&type=template&id=a1a1e32c&scoped=true"
import script from "./mitra-tna-report.vue?vue&type=script&lang=js"
export * from "./mitra-tna-report.vue?vue&type=script&lang=js"
import style0 from "./mitra-tna-report.vue?vue&type=style&index=0&id=a1a1e32c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1a1e32c",
  null
  
)

export default component.exports